const settingsReducer = (state = { list : [], selected: false }, action) => {
  switch (action.type) {
    case "GET_SETTINGS_LIST_SUCCESS":
      return { ...state, list: action.payload }
    case "GET_SETTINGS_DETAILS_SUCCESS":
      return { ...state, selected: action.payload }
    default:
      return state
  }
}

export default settingsReducer